import { SidebarLeftCollapseIcon, SidebarLeftExpandIcon } from '../../icons'
import { AstraTooltip } from '../AstraTooltip/AstraTooltip'
import { AstraButton, AstraButtonOnlyProps } from '../Inputs/AstraButton/AstraButton'

type Props = AstraButtonOnlyProps & {
    isOpen: boolean
    toggleOpen: () => void
}

export const AstraSideNavTrigger = ({ ref, isOpen, toggleOpen, onClick, ...props }: Props) => {
    const label = `${!isOpen ? 'Åpne' : 'Lukk'} sidemeny`

    return (
        <AstraTooltip side="bottom" tooltipContent={label}>
            <AstraButton
                variant="secondary"
                ref={ref}
                data-sidebar="trigger"
                icon={isOpen ? <SidebarLeftCollapseIcon /> : <SidebarLeftExpandIcon />}
                onClick={event => {
                    onClick?.(event)
                    toggleOpen()
                }}
                data-test="left-sidebar-expand-button"
                {...props}
            />
        </AstraTooltip>
    )
}
